<template>
  <ValidationProvider ref="emailProvider" :name="$attrs['name'] || 'email'" rules="required|email" v-slot="{ errors }">
    <label class="pb-2">{{ label }}</label>
    <v-text-field solo type="email" class="form-control" :maxlength="length" v-bind="$attrs" @input="onInput($event)"
      :placeholder="placeholder">
    </v-text-field>
    <span style="color:#f75555">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EmailComponent extends Vue {
  @Prop({ default: '' }) inputValue!: string;
  @Prop({ default: 50 }) length!: number;
  @Prop({ default: -1 }) index!: number;
  @Prop({ default: 'الرجاء ملء الحقل' }) placeholder!: string;
  @Prop({ default: '' }) label!: string;

  async onInput(value: string): Promise<void> {
    const result = await (this.$refs.emailProvider as any).validate(value);
    this.$emit('input', value);
    this.$emit('update:inputValue', value);

    if (this.index !== -1) {
      this.$emit('controlDataChanged', { value, index: this.index, isValid: result.valid });
    }
  }
}
</script>
